eshopApp.controller('QuickModalsController', ['$scope', '$uibModalInstance', 'message', function ($scope, $uibModalInstance, message) {

	$scope.message = message;

	$scope.ok = function () {
		$uibModalInstance.close('ok');
	};

	$scope.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};
	
}]);